module.exports = __webpack_public_path__ + "static/media/preview.3186944c.png";